import { Controller } from "stimulus";
import { errorDialog } from '../helpers/swal_helper';

export default class extends Controller {
  static targets = ["studentSelect", "amountInput", "paymentTypeSelect", "paymentForSelect", "paymentFromId", "paymentUntilHide", "chequeInput", "form"];

  connect() {
    this.studentFees = this.loadStudentFees();
    this.currentFee = null;
    this.initEventListeners();
  }

  loadStudentFees() {
    try {
      return JSON.parse(this.studentSelectTarget.dataset.students || '{}');
    } catch (e) {
      console.error("Error parsing student fee data", e);
      return {};
    }
  }

  initEventListeners() {
    $(this.studentSelectTarget).on('change', () => this.onStudentChange());
    this.amountInputTarget.addEventListener('input', () => this.onAmountInput());
    this.paymentTypeSelectTarget.addEventListener('change', () => this.onPaymentTypeChange());
    this.paymentForSelectTarget.addEventListener('change', () => {
      this.onPaymentForChange();
      this.onAmountInput();
    });
  }

  onStudentChange() {
    const studentId = this.studentSelectTarget.value;
    this.currentFee = this.studentFees[studentId] || null;
    this.removeAmountError();

    if (this.currentFee !== null) {
      this.amountInputTarget.placeholder = `Outstanding fee: ${this.currentFee}`;
      this.amountInputTarget.value = this.currentFee;
    } else {
      this.amountInputTarget.placeholder = 'Please enter amount';
      this.amountInputTarget.value = '';
    }
  }

  onAmountInput() {
    const entered = parseFloat(this.amountInputTarget.value);
    const paymentFor = this.paymentForSelectTarget.value;

    if (paymentFor === 'fees' && this.currentFee !== null && entered > this.currentFee) {
      this.showAmountError(`Entered amount exceeds outstanding fee of ${this.currentFee}`);
    } else {
      this.removeAmountError();
    }
  }

  showAmountError(message) {
    this.amountInputTarget.classList.add('is-invalid');

    let errorSpan = this.amountInputTarget.nextElementSibling;
    if (!errorSpan || !errorSpan.classList.contains('invalid-feedback')) {
      errorSpan = document.createElement('div');
      errorSpan.className = 'invalid-feedback';
      this.amountInputTarget.parentNode.appendChild(errorSpan);
    }

    errorSpan.textContent = message;
  }

  removeAmountError() {
    this.amountInputTarget.classList.remove('is-invalid');

    const errorSpan = this.amountInputTarget.nextElementSibling;
    if (errorSpan && errorSpan.classList.contains('invalid-feedback')) {
      errorSpan.remove();
    }
  }

  onPaymentTypeChange() {
    if (this.paymentTypeSelectTarget.value === 'cheque') {
      this.chequeInputTarget.classList.remove('d-none');
    } else {
      this.chequeInputTarget.classList.add('d-none');
    }
  }

  onPaymentForChange() {
    this.paymentUntilHideTarget.classList.add('d-none');
    const input = this.paymentFromIdTarget.querySelector(".form-control");
    if (this.paymentForSelectTarget.value === "fees") {
      this.paymentFromIdTarget.classList.remove("d-none");
      if (input) input.setAttribute("required", "required");
    } else {
      this.paymentFromIdTarget.classList.add("d-none");
      if (input) input.removeAttribute("required");
    }
  }
}
